import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {MoveScheduleOccurrenceInput, ScheduleRepository} from '../ports/schedule.repository';

export class MoveScheduleOccurrence implements UseCase<[MoveScheduleOccurrenceInput], void> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(input: MoveScheduleOccurrenceInput): Promise<Result<void, ScheduleError>> {
    return this.repository.moveOccurrence(input);
  }
}
